import React from 'react';
import { Box, LinearProgress, Typography, Paper } from '@mui/material';

/**
 * Simplified LoadingOverlay component that displays basic progress information
 * 
 * @param {boolean} isLoading - Whether the overlay should be shown
 * @param {string} message - Default message to display if no progress data is available
 * @param {object} progress - Progress data object with status, message, progress percentage
 */
const LoadingOverlay = ({ isLoading = true, message = 'Processing...', progress = null, title = 'Filter Processing' }) => {
  if (!isLoading) return null;
  
  // Extract data from progress object
  const overallProgress = progress?.progress || 0;
  const statusMessage = progress?.message || message;
  
  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        zIndex: 1000,
      }}
    >
      <Paper
        elevation={4}
        sx={{
          width: '400px',
          maxWidth: '90%',
          p: 3,
          borderRadius: 2,
          textAlign: 'center'
        }}
      >
        {/* Overall progress */}
        <Typography variant="h6" gutterBottom>
          {title}: {Math.round(overallProgress)}%
        </Typography>
        
        <Box sx={{ width: '100%', mb: 2 }}>
          <LinearProgress 
            variant="determinate"
            value={overallProgress}
            sx={{ height: 10, borderRadius: 5 }}
          />
        </Box>
        
        {/* Status message */}
        <Typography variant="body2" sx={{ fontStyle: 'italic' }}>
          {statusMessage}
        </Typography>
      </Paper>
    </Box>
  );
};

export default LoadingOverlay;
